var FileWrapper = require('filewrapper');


var FileProgressView = Backbone.View.extend({
    model: FileWrapper,
    tagName: 'li',
    className: 'fileProgress starting',
    initialize: function (options) {
    },
    events: {
        'click .cancel': 'clickCancel',
        'click .remove': 'clickRemove',
        'click a.file': 'clickFile'
    },
    clickFile: function (e) {
        if (this.model.showMessage()) {
            e.preventDefault();
        }
    },
    clickCancel: function (e) {
        e.preventDefault();
        this.model.cancelUpload();
    },
    clickRemove: function (e) {
        e.preventDefault();
        this.remove();
    },
    remove: function (callback) {
        var args = arguments;
        this.$el.slideUp(_.bind(function () {
            Backbone.View.prototype.remove.apply(this, args);
            if (callback) {
                callback();
            }
        }, this));
        return this;
    },
    uploadProgress: function (e, percentComplete) {
        this.setStatusClass('progress');
        this.progress.stop().animate({
            'width': percentComplete + '%'
        });
        this.status.text(percentComplete + '%');
    },
    uploadFinalise: function () {
        this.setStatusClass('finalising');
        this.status.text('Finishing…');
    },
    uploadCancelled: function () {
        this.setStatusClass('cancelled');
        this.status.text('Cancelled');
        this.uploadDone();
    },
    uploadError: function () {
        this.setStatusClass('error');
        this.status.text('Failed');
        this.uploadDone();
    },
    uploadSuccess: function () {
        this.render(true);
    },
    setStatusClass: function (status) {
        this.$el.removeClass('starting progress finalising cancelled error');
        this.$el.addClass(status);
    },
    uploadDone: function () {
        this.progress.stop().css('width', 'auto');
    },
    render: function (done) {
        var table = $('<table class="fileTable" cellpadding="0" cellspacing="0">');

        this.name = $('<td class="name" colspan="2">').text(this.model.getName());
        table.append($('<tr>').append(this.name));

        var infoStatus = $('<tr class="infoStatus">');

        var fileInfo = $('<td class="fileInfo explanation">')
            .append($('<span>').text(this.model.getSize()))
            .append(' • ')
            .append($('<span>').text(this.model.getType()));
        infoStatus.append(fileInfo);

        var statusCell = $('<td class="status">');
        this.status = $('<span class="statusText">');
        if (done) {
            this.status.text('Done');
        }
        statusCell.append(this.status);
        this.progress = $('<div class="progressBar">');
        statusCell.append(this.progress);
        infoStatus.append(statusCell);

        table.append(infoStatus);

        this.$el.empty();

        var link = $('<a href="" class="file" target="_blank">');
        if (done) {
            link.attr('href', this.model.getUrl());
            this.setStatusClass('success');
        }
        this.$el.append(link.append(table));

        this.rendered();

        return this;
    },
    rendered: function () {
        this.model.bind('uploadProgress', this.uploadProgress, this);
        this.model.bind('uploadFinalise', this.uploadFinalise, this);
        this.model.bind('uploadSuccess', this.uploadSuccess, this);
        this.model.bind('uploadCancelled', this.uploadCancelled, this);
        this.model.bind('uploadError', this.uploadError, this);
        return this;
    }
});

module.exports = FileProgressView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/fileprogressview.js
// module id = 0lcd
// module chunks = 1